/* AD Perfumes — collection and search filtering/sorting.
   Uses Shopify's native filter URL parameters. Results are re-rendered by
   Shopify (Section Rendering API); if that fails, the page simply navigates. */
(function () {
  'use strict';

  var ADP = (window.ADP = window.ADP || {});

  function getSection() {
    return document.querySelector('[data-facets-section]');
  }

  function buildUrl(form) {
    var params = new URLSearchParams();
    new FormData(form).forEach(function (value, key) {
      if (value !== '' && value !== null) params.append(key, value);
    });
    var base = form.getAttribute('action');
    var qs = params.toString();
    return qs ? base + '?' + qs : base;
  }

  function lockScroll(lock) {
    document.body.classList.toggle('scroll-locked', !!lock && window.matchMedia('(max-width: 989px)').matches);
  }

  function openPanel(open) {
    var section = getSection();
    if (!section) return;
    var panel = section.querySelector('[data-facets-panel]');
    var toggle = section.querySelector('[data-facets-toggle]');
    if (!panel) return;
    panel.classList.toggle('is-open', open);
    if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    var overlay = document.querySelector('.facets-overlay');
    if (open && !overlay) {
      overlay = document.createElement('div');
      overlay.className = 'facets-overlay';
      overlay.addEventListener('click', function () { openPanel(false); });
      document.body.appendChild(overlay);
    } else if (!open && overlay) {
      overlay.remove();
    }
    lockScroll(open);
    if (open) {
      var first = panel.querySelector('summary, input, button');
      if (first) first.focus();
    } else if (toggle) {
      toggle.focus();
    }
  }

  var controller;
  function render(url, pushState) {
    var section = getSection();
    if (!section) { window.location.href = url; return; }
    var sectionId = section.getAttribute('data-section-id');
    var layout = section.querySelector('.results-layout');
    var panelWasOpen = !!section.querySelector('[data-facets-panel].is-open');
    var activeId = document.activeElement && document.activeElement.id;
    if (layout) layout.classList.add('is-loading');

    if (controller) controller.abort();
    controller = 'AbortController' in window ? new AbortController() : null;

    var fetchUrl = url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sectionId);
    fetch(fetchUrl, controller ? { signal: controller.signal } : {})
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-facets-section]');
        if (!fresh) throw new Error('missing');
        section.innerHTML = fresh.innerHTML;
        if (pushState !== false) window.history.pushState({ facets: true }, '', url);
        if (panelWasOpen) {
          var panel = section.querySelector('[data-facets-panel]');
          var toggle = section.querySelector('[data-facets-toggle]');
          if (panel) panel.classList.add('is-open');
          if (toggle) toggle.setAttribute('aria-expanded', 'true');
        } else {
          var overlay = document.querySelector('.facets-overlay');
          if (overlay) overlay.remove();
          lockScroll(false);
        }
        if (activeId) {
          var el = document.getElementById(activeId);
          if (el) el.focus({ preventScroll: true });
        }
        document.dispatchEvent(new CustomEvent('adp:content-loaded', { detail: { root: section } }));
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        window.location.href = url;
      });
  }

  var debouncedPrice = ADP.debounce(function (form) { render(buildUrl(form)); }, 800);

  document.addEventListener('change', function (e) {
    var form = e.target.closest('[data-facets-form]');
    if (!form) return;
    if (e.target.matches('[data-facets-price]')) { debouncedPrice(form); return; }
    render(buildUrl(form));
  });

  document.addEventListener('input', function (e) {
    var form = e.target.closest('[data-facets-form]');
    if (form && e.target.matches('[data-facets-price]')) debouncedPrice(form);
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-facets-form]');
    if (!form) return;
    e.preventDefault();
    render(buildUrl(form));
    openPanel(false);
  });

  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-facets-link]');
    if (link) {
      e.preventDefault();
      render(link.getAttribute('href'));
      return;
    }
    if (e.target.closest('[data-facets-toggle]')) {
      var panel = getSection() && getSection().querySelector('[data-facets-panel]');
      openPanel(!(panel && panel.classList.contains('is-open')));
      return;
    }
    if (e.target.closest('[data-facets-close]')) openPanel(false);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var panel = getSection() && getSection().querySelector('[data-facets-panel].is-open');
    if (panel) openPanel(false);
  });

  window.addEventListener('popstate', function () {
    if (getSection()) render(window.location.href, false);
  });
})();
